// extracted by mini-css-extract-plugin
module.exports = {"xs":"375px","sm":"600px","md":"834px","lg":"1280px","xl":"1280px","wrapper":"SubHeader-module__wrapper___210jB","hidden":"SubHeader-module__hidden___2faw1"};